<template>
  <div class="market-price-change-chart">
    <div class="market-price-change-chart__chart" ref="chart"></div>
  </div>
</template>

<script src="./market-price-change-chart.js"></script>
<style src="./market-price-change-chart.scss" lang="scss"></style>
